import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import MarkDown from '../components/MarkDown';
import Footer from '../components/Footer';
import { AdIcons } from '../components/Ad';
import '../blog.css';
import {
  DEFAULT_IMAGE,
  extractMarkdownMetadata,
  fetchStaticMarkdown,
} from '../utils/markdownContent';

function Blog() {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState('');
  const { id } = useParams();
  const PROTECTED_POST_ID = '115';
  const PASSWORD = '1145141919';
  const isProtected = id === PROTECTED_POST_ID;
  const [isAuthorized, setIsAuthorized] = useState(!isProtected);
  const [passwordInput, setPasswordInput] = useState('');
  const [passwordError, setPasswordError] = useState('');

  useEffect(() => {
    if (isProtected) {
      setIsAuthorized(false);
      setPasswordInput('');
      setPasswordError('');
      setTitle('保護された記事');
      setDescription('この記事を閲覧するにはパスワードが必要です。');
      setImage('https://www.asmrchurch.com/static/images/i4.jpg');
      return;
    }

    setIsAuthorized(true);
  }, [id, isProtected]);

  useEffect(() => {
    if (!isAuthorized) {
      return undefined;
    }

    let isMounted = true;

    const fetchMetadata = async () => {
      try {
        const text = await fetchStaticMarkdown(`/blog/${id}`);
        if (!isMounted) {
          return;
        }
        const metadata = extractMarkdownMetadata(text, {
          description: 'ASMRキリスト教会のブログ',
        });
        const resolvedTitle = metadata.title
          ? `${metadata.title} - ASMRキリスト教会`
          : 'ブログ - ASMRキリスト教会';
        setTitle(resolvedTitle);
        setDescription(metadata.description || 'ASMRキリスト教会のブログ');
        setImage(metadata.image || DEFAULT_IMAGE);
      } catch (error) {
        console.error(error);
        if (isMounted) {
          setTitle('ブログ - ASMRキリスト教会');
          setDescription('ASMRキリスト教会のブログ');
          setImage(DEFAULT_IMAGE);
        }
      }
    };

    fetchMetadata();

    return () => {
      isMounted = false;
    };
  }, [id, isAuthorized]);

  const url = `https://www.asmrchurch.com/blog/${id}`;

  const handlePasswordSubmit = (event) => {
    event.preventDefault();

    if (passwordInput === PASSWORD) {
      setIsAuthorized(true);
      setPasswordError('');
      setPasswordInput('');
    } else {
      setPasswordError('パスワードが違います。');
    }
  };

  return (
    <div>
      <Header
        title={title || 'ブログ - ASMRキリスト教会'}
        description={description}
        url={url}
        image={image}
      />
      <div className="flex-container">
        <div className="left-area">
          <AdIcons />
        </div>
        <div className="cont2">
          {isProtected && !isAuthorized ? (
            <div className="protected-article">
              <p>このブログ記事はパスワードで保護されています。</p>
              <form onSubmit={handlePasswordSubmit}>
                <input
                  id="blog-password"
                  type="password"
                  value={passwordInput}
                  onChange={(event) => {
                    setPasswordInput(event.target.value);
                    if (passwordError) {
                      setPasswordError('');
                    }
                  }}
                  placeholder="パスワード"
                />
                <button type="submit">開く</button>
              </form>
              {passwordError && <p className="password-error">{passwordError}</p>}
            </div>
          ) : (
            <MarkDown
              articleType="blog"
              articleId={id}
              fallbackPath={`/blog/${id}`}
            />
          )}
          <a href="/blog">ブログ一覧</a>
          <div className="return">
          </div>
          <div className="mobile-ads">
            <AdIcons />
          </div>
        </div>
        <div className="right-area">
          <span className="pad">
            {/*
            <stripe-buy-button
              buy-button-id="buy_btn_1QiEyXJrEFc0aoshZrg6uGA0"
              publishable-key="pk_live_51L77y9JrEFc0aoshDbT8faRDJBWQJjQTGvMb6jngK3GGGpMtIYf8omncPkMd8e0be0ZsfG2yEWaxYdMSlGSS9pgX00RNzmWvfw"
            >
            </stripe-buy-button>
            */}
          </span>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Blog;
